(() => {
  const runtime = window.CovermaticRuntime || window.AlphaRuntime || {};
  window.CovermaticRuntime = runtime;
  window.AlphaRuntime = runtime;
  const Utils = runtime.Utils;
  const AppApi = window.CovermaticApp || window.AlphaApp;
  const previewModal = document.getElementById('template-preview-modal');
  const previewImage = document.getElementById('template-preview-image');
  const previewTitle = document.getElementById('template-preview-title');
  const previewSelect = document.getElementById('template-preview-select');

  if (!previewModal || !previewImage || !previewTitle || !previewSelect) return;

  let activeCard = null;

  const enhanceArtworkCard = (card) => {
    if (!card || !(card instanceof HTMLElement)) return null;

    let enhancedCard = card;

    if (enhancedCard.tagName === 'BUTTON') {
      const replacement = document.createElement('article');
      replacement.className = enhancedCard.className;
      replacement.innerHTML = enhancedCard.innerHTML;

      Array.from(enhancedCard.attributes).forEach((attribute) => {
        if (attribute.name === 'class' || attribute.name === 'type') return;
        replacement.setAttribute(attribute.name, attribute.value);
      });

      replacement.setAttribute('role', 'button');
      replacement.tabIndex = 0;
      enhancedCard.replaceWith(replacement);
      enhancedCard = replacement;
    } else {
      enhancedCard.setAttribute('role', 'button');
      if (!enhancedCard.hasAttribute('tabindex')) enhancedCard.tabIndex = 0;
    }

    let media = enhancedCard.querySelector('.tpl-card__media');
    const image = enhancedCard.querySelector('img');

    if (!media && image) {
      media = document.createElement('div');
      media.className = 'tpl-card__media';
      image.parentNode.insertBefore(media, image);
      media.appendChild(image);
    }

    enhancedCard.dataset.previewEnhanced = 'true';
    return enhancedCard;
  };

  const enhanceArtworkCards = (root = document) => {
    const cards = root.matches?.('.tpl-card') ? [root] : Array.from(root.querySelectorAll?.('.tpl-card') || []);
    cards.forEach(enhanceArtworkCard);
  };

  const openPreview = (card) => {
    const enhancedCard = enhanceArtworkCard(card);
    if (!enhancedCard?.dataset?.image) return;

    activeCard = enhancedCard;
    previewImage.src = enhancedCard.dataset.image;
    previewImage.alt = enhancedCard.dataset.title || 'Artwork preview';
    previewTitle.textContent = enhancedCard.dataset.title || 'Artwork preview';
    previewSelect.textContent = enhancedCard.dataset.signatureStyleAssetIndex ? 'Use This Style' : 'Use This Cover Art';
    previewModal.classList.remove('hidden');
    previewModal.classList.add('flex');
    Utils?.syncBodyLock?.();
  };

  const closePreview = () => {
    previewModal.classList.add('hidden');
    previewModal.classList.remove('flex');
    activeCard = null;
    Utils?.syncBodyLock?.();
  };

  const triggerSelection = async (card) => {
    if (!card) return;

    if (card.dataset?.signatureStyleAssetIndex && typeof AppApi?.modals?.selectSignatureStyleAsset === 'function') {
      await AppApi.modals.selectSignatureStyleAsset(card.dataset.signatureStyleAssetIndex);
      return;
    }

    if (typeof AppApi?.modals?.selectTemplate === 'function') {
      await AppApi.modals.selectTemplate(card);
    }
  };

  document.addEventListener('click', async (event) => {
    if (
      event.target.closest('[data-template-preview-close]') ||
      (event.target.dataset.close === 'overlay' && event.target.closest('#template-preview-modal')) ||
      event.target.closest('#template-preview-modal [data-close="x"]')
    ) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closePreview();
      return;
    }

    if (event.target.closest('#template-preview-select')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const selectedCard = activeCard;
      closePreview();
      await triggerSelection(selectedCard);
      return;
    }

    const card = event.target.closest('.tpl-card');
    if (!card || event.target.closest('#template-preview-modal')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    openPreview(card);
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !previewModal.classList.contains('hidden')) {
      event.preventDefault();
      closePreview();
      return;
    }

    if (event.key !== 'Enter' && event.key !== ' ') return;

    const card = event.target.closest('.tpl-card[role="button"]');
    if (!card) return;

    event.preventDefault();
    openPreview(card);
  }, true);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        enhanceArtworkCards(node);
      });
    });
  });

  enhanceArtworkCards(document);
  observer.observe(document.body, { childList: true, subtree: true });
})();
